import { CssBaseline, Paper } from '@material-ui/core';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { useGenericStyles } from 'common/genericStyles';
import { FuncaoParticipante, GrupoAcesso, Perfil } from 'common/genericTypes';
import { AvatarMenu } from 'components/avatarMenu/avatarMenu';
import Header, { HEADER_WIDTH } from 'components/header';
import history from 'components/history';
import { Loader } from 'components/loader';
import GlobalSnackBar from 'components/snackBar';
import { MdSpace } from 'm2m.components';
import Aprovacoes from 'pages/aprovacoes';
import DetalhesCra from 'pages/cra/detalhes';
import DetalhesCdca from 'pages/cdca/detalhes';
import DetalhesCri from 'pages/cri/detalhes';
import DetalhesDebenture from 'pages/debenture/detalhes';
import DetalhesNotaComercial from 'pages/notaComercial/detalhes';
import DetalhesCertificadoRecebiveis from 'pages/certificadoRecebiveis/detalhes';
import DetalhesCotasDeFundo from 'pages/cotasDeFundo/detalhes';
import LiquidacaoEventos from 'pages/instrumentos/eventos/liquidacao';
import InstrumentosLista from 'pages/instrumentos/gerenciar';
import CadastroCra from 'pages/cra/registro';
import CadastroCdca from 'pages/cdca/registro';
import CadastroCotasDeFundo from 'pages/cotasDeFundo/registro';
import CadastroCri from 'pages/cri/registro';
import CadastroDebenture from 'pages/debenture/registro';
import CadastroNotaComercial from 'pages/notaComercial/registro';
import CadastroCertificadoRecebiveis from 'pages/certificadoRecebiveis/registro';
import InstrumentoInterOp from 'pages/instrumentos/registroInteroperabilidade';
import CraInterOp from 'pages/cra/registro/formularioInteroperabilidade';
import CdcaInterOp from 'pages/cdca/registro/formularioInteroperabilidade';
import CriInterOp from 'pages/cri/registro/formularioInteroperabilidade';
import DebentureInterOp from 'pages/debenture/registro/formularioInteroperabilidade';
import NotaComercialInterOp from 'pages/notaComercial/registro/formularioInteroperabilidade';
import CertificadoRecebiveisInterOp from 'pages/certificadoRecebiveis/registro/formularioInteroperabilidade';
import CadastroInstrumento from 'pages/instrumentos/registro';
import DetalhesBloqueio from 'pages/investidores/bloqueios/detalhes';
import CadastrarBloqueio from 'pages/investidores/bloqueios/registro';
import CadastroBloqueioPorGarantia from 'pages/investidores/bloqueios/registro/garantia';
import DetalhesInvestidor from 'pages/investidores/detalhes';
import GerenciarInvestidores from 'pages/investidores/gerenciar';
import CadastrarInvestidor from 'pages/investidores/registro';
import Login from 'pages/login';
import NovaSenha from 'pages/login/novaSenha';
import NovoUsuario from 'pages/login/novoUsuario';
import OperacoesLista from 'pages/operacoes/gerenciar';
import CadastrarOperacoes from 'pages/operacoes/registro';
import CadastrarOperacaoOfertaPrimaria from 'pages/operacoes/registro/ofertaPrimaria';
import CadastrarOperacaoTransferencia from 'pages/operacoes/registro/transferencia';
import TransferenciaUnificada from 'pages/operacoes/registro/transferenciaUnificada';
import CadastrarOperacaoInterop from 'pages/operacoes/registro/transferenciaInterop';
import SolicitarOperacaoInterop from 'pages/operacoes/registro/transferenciaInterop/solicitacao';
import CadastrarCancelamentoQuantidades from 'pages/operacoes/registro/cancelamentoQuantidades';
import DetalhesOperacaoOfertaPrimaria from 'pages/operacoes/ofertaPrimaria/detalhes';
import DetalhesOperacaoCompraVenda from 'pages/operacoes/compraVenda/detalhes';
import DetalhesOperacaoInterop from 'pages/operacoes/detalhes/interoperabilidade';
import DetalhesParticipante from 'pages/participantes/detalhes';
import GerenciarParticipante from 'pages/participantes/gerenciar';
import CadastroParticipante from 'pages/participantes/registro';
import Solicitacoes from 'pages/solicitacoes';
import Liquidacoes from 'pages/liquidacoes';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { RootState } from 'store';
import CadastrarOperacaoVenda from './operacoes/registro/venda';
import Usuarios from 'pages/admin';
import GestaoAcessos from 'pages/gestaoAcessos';
import CredenciadosEmissor from 'pages/credenciados';
import Parametrizacoes from './parametrizacoes';
import { Modulos } from 'common/genericTypes';
import Certidoes from 'pages/certidoes';
import UploadArquivos from 'pages/uploadArquivos';
import DetalhesTransferencia from './operacoes/detalhes/transferencia';
import CadastrarOperacaoCompraVendaCompromissada from './operacoes/registro/compraVendaCompromissada';
import KeycloakWrap from './login/keycloak';
import NovoCadastroMovimentacao from './operacoes/registro/novoCadastroMovimentacao';
import DelimitacaoEmLote from './delimitacaoEmLote';
import LancamentoPU from './lancamentoPU';
import MapaAlocacao from './mapaAlocacao';
import AtualizacaoCota from './cotasDeFundo/atualizacaoCota';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00E08E',
    },
    secondary: {
      main: '#fff',
    },
    error: {
      main: '#FF5A5F',
    },
    warning: {
      main: '#FFCF40',
    },
  },
  typography: {
    fontFamily: ['Circular', 'Publico Bold', 'Roboto'].join(','),
    h1: {
      fontSize: '88px',
      fontWeight: 600,
      fontFamily: 'Publico Bold',
    },
    h2: {
      fontSize: '56px',
      fontWeight: 600,
      fontFamily: 'Publico Bold',
    },
    h3: {
      fontSize: '24px',
      fontWeight: 400,
      fontFamily: 'Publico Bold',
    },
    body1: {
      fontSize: '16px',
      fontFamily: 'Circular Bold',
      lineHeight: '24px',
    },
    body2: {
      fontSize: '16px',
      fontFamily: 'Circular',
      lineHeight: '24px',
    },
    subtitle1: {
      fontSize: '12px',
      fontFamily: 'Circular Bold',
      lineHeight: '18px',
    },
    subtitle2: {
      fontSize: '12px',
      fontFamily: 'Circular',
      lineHeight: '18px',
    },
    button: {
      fontFamily: 'Circular Bold',
      fontSize: '12px',
      lineHeight: '15px',
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: '24px',
        fontSize: '12px',
        padding: '16px 30px',
      },
      sizeSmall: {
        padding: '10px 20px',
      },
      outlined: {
        padding: '16px 30px',
      },
      containedPrimary: {
        '&:hover': {
          backgroundColor: '#00E08E',
        },
      },
      containedSecondary: {
        border: `1px solid #00E08E`,
        '&:hover': {
          backgroundColor: 'inherit',
        },
      },
      outlinedSecondary: {
        border: `1px solid black`,
        color: 'black',
        '&:hover': {
          border: `1px solid black`,
        },
      },
    },
  },
});

const SERVICE_DESK_SCRIPT_ELEMENT_ID = 'service-desk-script';
const SERVICE_DESK_IFRAME_ELEMENT_ID = 'jsd-widget';

const App: React.FC = () => {
  const isAuth = useSelector((state: RootState) => state.auth.isAuth);
  const usuario = useSelector((state: RootState) => state.auth.usuario);
  const isUsuarioControlesInternos = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.ControlesInternos
  );
  const isUsuarioOperacoes = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.Operacoes
  );
  const isUsuarioCadastroOperacoes = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.CadastroOperacoes
  );

  const isUsuarioOperacoesLeitura = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.OperacoesLeitura
  );
  const isUsuarioCadastroLeitura = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.OperacoesLeitura
  );
  const isUsuarioGestaoAcessos = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.GestaoAcessos
  );
  const isUsuarioComum = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.Comum
  );
  const isParticipanteEmissor = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Emissor
  );
  const isParticipanteEscriturador = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Escriturador
  );
  const isParticipanteAgenteFiduciario = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.AgenteFiduciario
  );
  const isParticipanteCustodiante = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Custodiante
  );
  const isParticipanteCredenciado = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Credenciado
  );

  const isUsuarioMaster = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Master);
  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);

  const isUsuarioModuloInstrumentoFinanceiro = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.INSTRUMENTO_FINANCEIRO)));
  const isUsuarioModuloAprovacoes = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.APROVACOES)));
  const isUsuarioModuloSolicitacoes = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.SOLICITACOES)));
  const isUsuarioModuloParticipantes = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.PARTICIPANTES)));
  const isUsuarioModuloInvestidores = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.INVESTIDORES)));
  const isUsuarioModuloMovimentacoes = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.MOVIMENTACOES)));
  const isUsuarioModuloGestaoAcessos = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.GESTAO_ACESSOS)));
  const isUsuarioModuloParametrizacoes = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.PARAMETRIZACOES)));
  const isUsuarioModuloSolicitacaoCredenciamento = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.SOLICITACAO_CREDENCIAMENTO)));
  const isUsuarioModuloCertidoes = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.CERTIDOES)));
  const isUsuarioModuloUploadArquivos = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.UPLOAD_ARQUIVOS)));
  const isUsuarioModuloLiquidacoes = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.LIQUIDACOES)));
  const isUsuarioModuloDelimitacaoEmLote = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.DELIMITACAO_LOTE)));
  const isUsuarioModuloLancamentoPU = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.LANCAMENTO_PU)));
  const isUsuarioModuloAtualizacaoCotas = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.ATUALIZACAO_COTAS)));

  const genericClasses = useGenericStyles();

  useEffect(() => {
    const serviceDeskIframe = document.getElementById(SERVICE_DESK_IFRAME_ELEMENT_ID);

    if (isAuth) {
      if (serviceDeskIframe) serviceDeskIframe.style.display = '';
    } else if (serviceDeskIframe) serviceDeskIframe.style.display = 'none';
  }, [isAuth]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalSnackBar />
      <Loader />
      <Router history={history}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/sso" component={KeycloakWrap} />
          <Route exact path="/new-user/:conviteId" component={NovoUsuario} />
          <Route exact path="/nova-senha/:requestId" component={NovaSenha} />
          {/* <Route exact path="/no-auth/cadastro/participante">
            <CadastroParticipante renderFakeHeader />
          </Route> */}
          {!isAuth ? (
            <Redirect to={{ pathname: '/login', state: { from: history.location } }} />
          ) : (
            <>
              <Header />
              <Paper style={{ display: 'flex', minHeight: '100vh', height: '100%' }}>
                <main
                  style={{ width: `calc(100% - ${HEADER_WIDTH} - 40px)`, marginLeft: `calc(${HEADER_WIDTH} + 40px)` }}
                >
                  <MdSpace />
                  <AvatarMenu name={usuario.nome} description={usuario.participante.razaoSocial} />
                  <MdSpace />
                  <Route exact path="/instrumentos/gerenciar" component={InstrumentosLista} />
                  {isUsuarioModuloAprovacoes && (isUsuarioOperacoes || isParticipanteEscriturador || isUsuarioCadastroOperacoes || isParticipanteAgenteFiduciario) && <Route exact path="/aprovacoes" component={Aprovacoes} />}
                  
                  {(isUsuarioModuloSolicitacoes) && <Route exact path="/solicitacoes" component={Solicitacoes} />}
                  {(isUsuarioModuloSolicitacoes) && <Route path="/solicitacoes/filtro/:filtro" component={Solicitacoes} />}
                  
                  {!isUsuarioLeitura && (
                    <>
                      {(isUsuarioModuloInstrumentoFinanceiro) && (
                        <Route exact path="/instrumentos/gerenciar/cadastro" component={CadastroInstrumento} />
                      )}
                      {(isUsuarioModuloInstrumentoFinanceiro) && (
                        <Route exact path="/instrumentos/gerenciar/cadastro/cra" component={CadastroCra} />
                      )}
                      {(isUsuarioModuloInstrumentoFinanceiro) && (
                        <Route exact path="/instrumentos/gerenciar/cadastro/cdca" component={CadastroCdca} />
                      )}
                      {(isUsuarioModuloInstrumentoFinanceiro) && (
                        <Route exact path="/instrumentos/gerenciar/cadastro/cotas-de-fundo" component={CadastroCotasDeFundo} />
                      )}
                      {(isUsuarioModuloInstrumentoFinanceiro) && (
                        <Route exact path="/instrumentos/gerenciar/cadastro/cri" component={CadastroCri} />
                      )}
                      {(isUsuarioModuloInstrumentoFinanceiro) && (
                        <Route exact path="/instrumentos/gerenciar/cadastro/debenture" component={CadastroDebenture} />
                      )}
                      {(isUsuarioModuloInstrumentoFinanceiro) && (
                        <Route
                          exact
                          path="/instrumentos/gerenciar/cadastro/nota-comercial"
                          component={CadastroNotaComercial}
                        />
                      )}
                      {(isUsuarioModuloInstrumentoFinanceiro) && (
                        <Route
                          exact
                          path="/instrumentos/gerenciar/cadastro/certificado-recebiveis"
                          component={CadastroCertificadoRecebiveis}
                        />
                      )}
                    </>
                  )}
                  {isUsuarioModuloInstrumentoFinanceiro && (
                    <Route exact path="/instrumentos/gerenciar/cras/:craId" component={DetalhesCra} />
                  )}
                  {isUsuarioModuloInstrumentoFinanceiro && (
                    <Route exact path="/instrumentos/gerenciar/cdcas/:cdcaId" component={DetalhesCdca} />
                  )}
                  {isUsuarioModuloInstrumentoFinanceiro && (
                    <Route exact path="/instrumentos/gerenciar/cotas-de-fundos/:cotasDeFundoId" component={DetalhesCotasDeFundo} />
                  )}
                  {isUsuarioModuloInstrumentoFinanceiro && (
                    <Route exact path="/instrumentos/gerenciar/cris/:criId" component={DetalhesCri} />
                  )}
                  {isUsuarioModuloInstrumentoFinanceiro && (
                    <Route exact path="/instrumentos/gerenciar/debentures/:debentureId" component={DetalhesDebenture} />
                  )}
                  {isUsuarioModuloInstrumentoFinanceiro && (
                    <Route
                      exact
                      path="/instrumentos/gerenciar/notas-comerciais/:notaComercialId"
                      component={DetalhesNotaComercial}
                    />
                  )}
                  {isUsuarioModuloInstrumentoFinanceiro && (
                    <Route
                      exact
                      path="/instrumentos/gerenciar/certificados-recebiveis/:certificadoRecebiveisId"
                      component={DetalhesCertificadoRecebiveis}
                    />
                  )}
                  {isUsuarioModuloInstrumentoFinanceiro && (
                    <Route
                      exact
                      path="/instrumentos/:instrumentoId/eventos/:eventoId/liquidacao"
                      component={LiquidacaoEventos}
                    />
                  )}
                  {!isUsuarioLeitura && (
                    <>
                      {isUsuarioModuloInstrumentoFinanceiro && (
                        <Route exact path="/instrumentos/gerenciar/cra/:craId" component={CadastroCra} />
                      )}
                      {isUsuarioModuloInstrumentoFinanceiro && (
                        <Route exact path="/instrumentos/gerenciar/cdca/:cdcaId" component={CadastroCdca} />
                      )}
                      {isUsuarioModuloInstrumentoFinanceiro && (
                        <Route exact path="/instrumentos/gerenciar/cotas-de-fundo/:cotasDeFundoId" component={CadastroCotasDeFundo} />
                      )}
                      {isUsuarioModuloInstrumentoFinanceiro && (
                        <Route exact path="/instrumentos/gerenciar/cri/:criId" component={CadastroCri} />
                      )}
                      {isUsuarioModuloInstrumentoFinanceiro && (
                        <Route
                          exact
                          path="/instrumentos/gerenciar/debenture/:debentureId"
                          component={CadastroDebenture}
                        />
                      )}
                      {isUsuarioModuloInstrumentoFinanceiro && (
                        <Route
                          exact
                          path="/instrumentos/gerenciar/nota-comercial/:notaComercialId"
                          component={CadastroNotaComercial}
                        />
                      )}
                      {isUsuarioModuloInstrumentoFinanceiro && (
                        <Route
                          exact
                          path="/instrumentos/gerenciar/certificado-recebiveis/:certificadoRecebiveisId"
                          component={CadastroCertificadoRecebiveis}
                        />
                      )}
                      {((isUsuarioOperacoes && isUsuarioModuloInstrumentoFinanceiro) || (isUsuarioCadastroOperacoes && isUsuarioModuloInstrumentoFinanceiro)) && (
                    <Route exact path="/instrumentos/gerenciar/cadastro/interop" component={InstrumentoInterOp} />
                  )}
                      {((isUsuarioOperacoes && isUsuarioModuloInstrumentoFinanceiro) || (isUsuarioCadastroOperacoes && isUsuarioModuloInstrumentoFinanceiro)) && (
                    <Route exact path="/instrumentos/gerenciar/cadastro/cra/interop" component={CraInterOp} />
                  )}
                      {((isUsuarioOperacoes && isUsuarioModuloInstrumentoFinanceiro) || (isUsuarioCadastroOperacoes && isUsuarioModuloInstrumentoFinanceiro)) && (
                    <Route exact path="/instrumentos/gerenciar/cadastro/cdca/interop" component={CdcaInterOp} />
                  )}
                      {((isUsuarioOperacoes && isUsuarioModuloInstrumentoFinanceiro) || (isUsuarioCadastroOperacoes && isUsuarioModuloInstrumentoFinanceiro)) && (
                    <Route exact path="/instrumentos/gerenciar/cadastro/cri/interop" component={CriInterOp} />
                  )}
                      {((isUsuarioOperacoes && isUsuarioModuloInstrumentoFinanceiro) || (isUsuarioCadastroOperacoes && isUsuarioModuloInstrumentoFinanceiro)) && (
                    <Route
                      exact
                      path="/instrumentos/gerenciar/cadastro/debenture/interop"
                      component={DebentureInterOp}
                    />
                  )}
                      {((isUsuarioOperacoes && isUsuarioModuloInstrumentoFinanceiro) || (isUsuarioCadastroOperacoes && isUsuarioModuloInstrumentoFinanceiro)) && (
                    <Route
                      exact
                      path="/instrumentos/gerenciar/cadastro/nota-comercial/interop"
                      component={NotaComercialInterOp}
                    />
                  )}
                      {((isUsuarioOperacoes && isUsuarioModuloInstrumentoFinanceiro) || (isUsuarioCadastroOperacoes && isUsuarioModuloInstrumentoFinanceiro)) && (
                    <Route
                      exact
                      path="/instrumentos/gerenciar/cadastro/certificado-recebiveis/interop"
                      component={CertificadoRecebiveisInterOp}
                    />
                  )}
                    </>
                  )}
                  {isUsuarioModuloParticipantes && (
                    <Route exact path="/gerenciar/participantes" component={GerenciarParticipante} />
                  )}
                  {(isUsuarioModuloParticipantes || isParticipanteCustodiante) && (
                    <Route exact path="/gerenciar/participantes/cadastro" component={CadastroParticipante} />
                  )}
                  {(isUsuarioModuloParticipantes || isParticipanteCustodiante) && (
                    <Route
                      exact
                      path="/gerenciar/participantes/detalhes/:participanteId"
                      component={DetalhesParticipante}
                    />
                  )}
                  {(isUsuarioModuloParticipantes || isParticipanteCustodiante) && (
                    <Route
                      exact
                      path="/gerenciar/participantes/detalhes/:participanteId/filtro/:filtro"
                      component={DetalhesParticipante}
                    />
                  )}
                  {!isUsuarioLeitura && ((isUsuarioOperacoes && isUsuarioModuloParticipantes) || (isUsuarioCadastroOperacoes && isUsuarioModuloParticipantes)) && (
                    <Route exact path="/gerenciar/participantes/editar/:participanteId">
                      <CadastroParticipante blockCategoria />
                    </Route>
                  )}
                  {isUsuarioModuloInvestidores && (
                    <Route exact path="/gerenciar/investidores" component={GerenciarInvestidores} />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloInvestidores && isParticipanteCustodiante && (
                    <Route exact path="/gerenciar/investidores/cadastro" component={CadastrarInvestidor} />
                  )}
                  {isUsuarioModuloInvestidores && (
                    <Route exact path="/gerenciar/investidores/detalhes/:investidorId" component={DetalhesInvestidor} />
                  )}
                  {!isUsuarioLeitura && isParticipanteCustodiante && isUsuarioModuloInvestidores && (
                    <Route exact path="/gerenciar/investidores/editar/:investidorId" component={CadastrarInvestidor} />
                  )}
                  {!isUsuarioLeitura && isUsuarioOperacoes && isUsuarioModuloInvestidores && (
                    <Route exact path="/gerenciar/investidores/bloqueios/cadastro" component={CadastrarBloqueio} />
                  )}
                  {isUsuarioModuloInvestidores && (
                    <Route
                      exact
                      path="/gerenciar/investidores/bloqueios/detalhes/:bloqueioId"
                      component={DetalhesBloqueio}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloInvestidores && isUsuarioOperacoes && (
                    <Route
                      exact
                      path="/gerenciar/investidores/bloqueios/garantia/cadastro"
                      component={CadastroBloqueioPorGarantia}
                    />
                  )}
                  {isUsuarioModuloMovimentacoes && (
                    <Route exact path="/operacoes/gerenciar" component={OperacoesLista} />
                  )}
                  {isUsuarioModuloMovimentacoes && (
                    <Route exact path="/operacoes/gerenciar/transferencias/:transferenciaId" component={DetalhesTransferencia} />
                  )}
                  {isUsuarioModuloMovimentacoes && (
                    <Route exact path="/operacoes/gerenciar/filtro/:filtro" component={OperacoesLista} />
                  )}
                  {isUsuarioModuloMovimentacoes && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/ofertas-primarias/:operacaoId"
                      component={DetalhesOperacaoOfertaPrimaria}
                    />
                  )}
                   {(isUsuarioModuloMovimentacoes) && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/ofertas-primarias/:operacaoId/filtro/:filtro"
                      component={DetalhesOperacaoOfertaPrimaria}
                    />
                  )}
                  <Route
                    exact
                    path="/operacoes/gerenciar/compras-vendas/:operacaoId"
                    component={DetalhesOperacaoCompraVenda}
                  />
                  {!isUsuarioLeitura && ((isParticipanteCustodiante && isUsuarioModuloMovimentacoes) || (isUsuarioOperacoes && isUsuarioModuloMovimentacoes)) && (
                    <Route exact path="/operacoes/gerenciar/cadastro" component={CadastrarOperacoes} />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isParticipanteCustodiante && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/oferta-primaria/cadastro"
                      component={NovoCadastroMovimentacao}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isParticipanteCustodiante && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/compra/cadastro"
                      component={NovoCadastroMovimentacao}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isParticipanteCustodiante && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/venda/cadastro"
                      component={CadastrarOperacaoVenda}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isParticipanteCustodiante && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/compra-venda-compromissada/cadastro"
                      component={CadastrarOperacaoCompraVendaCompromissada}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isUsuarioOperacoes && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/interoperabilidade/cadastro"
                      component={CadastrarOperacaoInterop}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isParticipanteCustodiante && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/interoperabilidade/solicitacao"
                      component={SolicitarOperacaoInterop}
                    />
                  )}
                  {((isUsuarioOperacoes && isUsuarioModuloMovimentacoes) || (isUsuarioCadastroOperacoes && isUsuarioModuloMovimentacoes)) && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/interoperabilidade/detalhes"
                      component={DetalhesOperacaoInterop}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isUsuarioOperacoes && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/transferencia/cadastro"
                      component={CadastrarOperacaoTransferencia}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isParticipanteCustodiante && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/transferencia-unificada/cadastro"
                      component={TransferenciaUnificada}
                    />
                  )}
                  {!isUsuarioLeitura && isUsuarioModuloMovimentacoes && isUsuarioOperacoes && (
                    <Route
                      exact
                      path="/operacoes/gerenciar/cancelamento/quantidades/cadastro"
                      component={CadastrarCancelamentoQuantidades}
                    />
                  )}
                  {isUsuarioModuloCertidoes && (
                    <Route exact path="/certidoes" component={Certidoes} />
                  )}
                  {isUsuarioModuloUploadArquivos && <Route exact path="/upload_arquivos" component={UploadArquivos} />}
                  {isUsuarioModuloLiquidacoes && <Route exact path="/liquidacoes" component={Liquidacoes} />}
                  {isUsuarioMaster && <Route exact path="/gerenciar/usuarios" component={Usuarios} />}
                  {isUsuarioMaster && <Route exact path="/credenciados/emissores" component={CredenciadosEmissor} />}
                  {isUsuarioOperacoes && <Route exact path="/parametrizacoes" component={Parametrizacoes} />}
                  {isUsuarioModuloDelimitacaoEmLote && <Route exact path="/delimitacao-em-lote" component={DelimitacaoEmLote} />}
                  {isUsuarioModuloDelimitacaoEmLote && <Route exact path="/mapa-alocacao" component={MapaAlocacao} />}
                  {isUsuarioModuloLancamentoPU && <Route exact path="/lancamento-pu" component={LancamentoPU} />}
                  {isUsuarioModuloAtualizacaoCotas && <Route exact path="/cotas-de-fundo/atualizacao-cota" component={AtualizacaoCota} />}
                  {(isUsuarioGestaoAcessos || (isUsuarioComum && isUsuarioMaster))
                    && <Route exact path="/gerenciar/acessos" component={GestaoAcessos} />}
                </main>
              </Paper>
            </>
          )}
        </Switch>
      </Router>
    </ThemeProvider>
  );
};

export default App;